import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CheckDuplicate } from 'components/CheckDuplicate';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useAddPage from 'hooks/useAddPage';
const PartnershopsAddPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		shopcode: yup.string().required().label("Shop Code"),
		shopname: yup.string().required().label("Shop Name"),
		ownername: yup.string().required().label("Owner Name"),
		contactphone: yup.string().required().label("Contact Phone"),
		contactemail: yup.string().email().required().label("Contact Email"),
		state: yup.string().required().label("State"),
		city: yup.string().required().label("City"),
		address: yup.string().required().label("Address"),
		zipcode: yup.string().nullable().label("Zipcode"),
		shoptype: yup.string().nullable().label("Shoptype"),
		status: yup.string().nullable().label("Status"),
		commissionrate: yup.number().required().label("Commission Rate"),
		serviceradius: yup.number().nullable().label("Servicer Radius (km)"),
		operatinghours: yup.string().nullable().label("Operating Hours(hours)"),
		capacityperday: yup.number().nullable().label("Capacity Per Day(kg)"),
		currentload: yup.number().nullable().label("Current Load(kg)"),
		rating: yup.number().nullable().label("Rating"),
		totalreviews: yup.number().nullable().label("Total Reviews"),
		registrationdate: yup.string().nullable().label("Registration Date"),
		lastactive: yup.string().nullable().label("Lastactive"),
		notes: yup.string().nullable().label("Notes"),
		userid: yup.number().nullable().label("Userid"),
		min_order_amt: yup.number().nullable().label("Min Order Amt")
	});
	
	//form default values
	const formDefaultValues = {
		shopcode: utils.randomNum(7), 
		shopname: '', 
		ownername: '', 
		contactphone: '', 
		contactemail: '', 
		state: '', 
		city: '', 
		address: '', 
		zipcode: '', 
		shoptype: '', 
		status: "Pending", 
		commissionrate: "20", 
		serviceradius: "((5.00))", 
		operatinghours: '', 
		capacityperday: "((50))", 
		currentload: "((0))", 
		rating: "4.5", 
		totalreviews: "((0))", 
		registrationdate: "(getdate())", 
		lastactive: "1", 
		notes: '', 
		userid: auth.userId, 
		min_order_amt: "((0))", 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/partnershops`);
		}
	}
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="PartnershopsAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label=""  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title="Add New Partnershop"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container-fluid">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Shop Code *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="shopcode"  onChange={formik.handleChange}  value={formik.values.shopcode}   label="Shop Code" type="text" placeholder="Enter Shop Code"     disabled   className={inputClassName(formik?.errors?.shopcode)} />
                                                <ErrorMessage name="shopcode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Shop Name *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="shopname"  onChange={formik.handleChange}  value={formik.values.shopname}   label="Shop Name" type="text" placeholder="Enter Shop Name"        className={inputClassName(formik?.errors?.shopname)} />
                                                <ErrorMessage name="shopname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Owner Name *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ownername"  onChange={formik.handleChange}  value={formik.values.ownername}   label="Owner Name" type="text" placeholder="Enter Owner Name"        className={inputClassName(formik?.errors?.ownername)} />
                                                <ErrorMessage name="ownername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Contact Phone *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="contactphone"  onChange={formik.handleChange}  value={formik.values.contactphone}   label="Contact Phone" type="text" placeholder="Enter Contact Phone"        className={inputClassName(formik?.errors?.contactphone)} />
                                                <ErrorMessage name="contactphone" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Contact Email *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <CheckDuplicate value={formik.values.contactemail} apiPath="components_data/partnershops_contactemail_exist">
                                                { (checker) => 
                                                <>
                                                <InputText name="contactemail" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.contactemail}   label="Contact Email" type="email" placeholder="Enter Contact Email"        className={inputClassName(formik?.errors?.contactemail)} />
                                                <ErrorMessage name="contactemail" component="span" className="p-error" />
                                                {(!checker.loading && checker.exist) && <small className="p-error">Not available</small>}
                                                {checker.loading && <small className="text-500">Checking...</small> }
                                                </>
                                                }
                                                </CheckDuplicate>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                State *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/state_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="state"     optionLabel="label" optionValue="value" value={formik.values.state} onChange={formik.handleChange} options={response} label="State"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.state)}   />
                                                    <ErrorMessage name="state" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                City *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource onLoad={(res) => formik.setFieldValue('city', '')} loadOnMount={false} apiPath={`components_data/city_option_list?lookup_state=${formik.values.state}`}  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="city"     optionLabel="label" optionValue="value" value={formik.values.city} onChange={formik.handleChange} options={response} label="City"  placeholder="Select a value ..."  className={inputClassName(formik?.errors?.city)}   />
                                                    <ErrorMessage name="city" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Address *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="address"  onChange={formik.handleChange}  value={formik.values.address}   label="Address" type="text" placeholder="Enter Address"        className={inputClassName(formik?.errors?.address)} />
                                                <ErrorMessage name="address" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Zipcode 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="zipcode"  onChange={formik.handleChange}  value={formik.values.zipcode}   label="Zipcode" type="text" placeholder="Enter Zipcode"        className={inputClassName(formik?.errors?.zipcode)} />
                                                <ErrorMessage name="zipcode" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Shoptype 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="shoptype"  onChange={formik.handleChange}  value={formik.values.shoptype}   label="Shoptype" type="text" placeholder="Enter Shoptype"        className={inputClassName(formik?.errors?.shoptype)} />
                                                <ErrorMessage name="shoptype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Status 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="status"  onChange={formik.handleChange}  value={formik.values.status}   label="Status" type="text" placeholder="Enter Status"     disabled   className={inputClassName(formik?.errors?.status)} />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Commission Rate *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="commissionrate"  onChange={formik.handleChange}  value={formik.values.commissionrate}   label="Commission Rate" type="number" placeholder="Enter Commission Rate"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.commissionrate)} />
                                                <ErrorMessage name="commissionrate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Servicer Radius (km) 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="serviceradius"  onChange={formik.handleChange}  value={formik.values.serviceradius}   label="Servicer Radius (km)" type="number" placeholder="Enter Servicer Radius (km)"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.serviceradius)} />
                                                <ErrorMessage name="serviceradius" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Operating Hours(hours) 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="operatinghours"  onChange={formik.handleChange}  value={formik.values.operatinghours}   label="Operating Hours(hours)" type="text" placeholder="Enter Operating Hours(hours)"        className={inputClassName(formik?.errors?.operatinghours)} />
                                                <ErrorMessage name="operatinghours" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Capacity Per Day(kg) 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="capacityperday"  onChange={formik.handleChange}  value={formik.values.capacityperday}   label="Capacity Per Day(kg)" type="number" placeholder="Enter Capacity Per Day(kg)"  min={0}  step="any"    className={inputClassName(formik?.errors?.capacityperday)} />
                                                <ErrorMessage name="capacityperday" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Current Load(kg) 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="currentload"  onChange={formik.handleChange}  value={formik.values.currentload}   label="Current Load(kg)" type="number" placeholder="Enter Current Load(kg)"  min={0}  step="any"    className={inputClassName(formik?.errors?.currentload)} />
                                                <ErrorMessage name="currentload" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Rating 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="rating"  onChange={formik.handleChange}  value={formik.values.rating}   label="Rating" type="number" placeholder="Enter Rating"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.rating)} />
                                                <ErrorMessage name="rating" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Total Reviews 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="totalreviews"  onChange={formik.handleChange}  value={formik.values.totalreviews}   label="Total Reviews" type="number" placeholder="Enter Total Reviews"  min={0}  step="any"    className={inputClassName(formik?.errors?.totalreviews)} />
                                                <ErrorMessage name="totalreviews" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Registration Date 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="registrationdate" value={formik.values.registrationdate} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.registrationdate)}        />
                                                <ErrorMessage name="registrationdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Lastactive 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="lastactive" value={formik.values.lastactive} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.lastactive)}        />
                                                <ErrorMessage name="lastactive" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Notes 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="notes"  onChange={formik.handleChange}  value={formik.values.notes}   label="Notes" type="text" placeholder="Enter Notes"        className={inputClassName(formik?.errors?.notes)} />
                                                <ErrorMessage name="notes" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Userid 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="userid"  onChange={formik.handleChange}  value={formik.values.userid}   label="Userid" type="number" placeholder="Enter Userid"  min={0}  step="any" disabled   className={inputClassName(formik?.errors?.userid)} />
                                                <ErrorMessage name="userid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                Min Order Amt 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="min_order_amt"  onChange={formik.handleChange}  value={formik.values.min_order_amt}   label="Min Order Amt" type="number" placeholder="Enter Min Order Amt"  min={0}  step={0.1}    className={inputClassName(formik?.errors?.min_order_amt)} />
                                                <ErrorMessage name="min_order_amt" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label="Submit" icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
PartnershopsAddPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'partnershops',
	apiPath: 'partnershops/add',
	routeName: 'partnershopsadd',
	submitButtonLabel: "Submit",
	formValidationError: "Form is invalid",
	formValidationMsg: "Please complete the form",
	msgTitle: "Create Record",
	msgAfterSave: "Record added successfully",
	msgBeforeSave: "",
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default PartnershopsAddPage;
